import { useContext } from 'react'
import { CurrentCustomerContext } from 'contexts'
import {
  DEFAULT_CUSTOMER_STATUS,
  LicensedAgency,
  CustomerInterface,
  CurrentCustomerState,
  CustomerAction,
} from 'contexts/CurrentCustomerContext'

const EMPTY_ARRAY: any[] = []

interface CurrentCustomerData {
  agencies: LicensedAgency[]
  connectors: CustomerInterface[]
  customerContext: CurrentCustomerState
  dispatch: (action: CustomerAction) => void
}

export const useCurrentCustomer: (
  customerAgencyId: string,
) => CurrentCustomerData = (customerAgencyId: string) => {
  const { state, dispatch } = useContext(CurrentCustomerContext)

  // if our current state's customer agency id doesn't match the desired one, then return empty data
  if (
    state.currentCustomer?.customer.customerAgencyId &&
    state.currentCustomer.customer.customerAgencyId !== customerAgencyId
  ) {
    return {
      agencies: EMPTY_ARRAY,
      connectors: EMPTY_ARRAY,
      customerContext: DEFAULT_CUSTOMER_STATUS.state,
      dispatch,
    }
  }

  const agencies: LicensedAgency[] =
    state.currentCustomer?.agencyList ?? EMPTY_ARRAY
  const connectors: CustomerInterface[] =
    state.currentCustomer?.connectorList ?? EMPTY_ARRAY

  return {
    agencies,
    connectors,
    customerContext: state,
    dispatch,
  }
}
